import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  title: 'Please choose items',
  direction: 'row',
  checkedIdx: 0,
  onActionCtaPressMetaData: {
    id: 'onActionCtaPressMetaData',
    actions: []
  },
  data: [{
    id: 'ITEM_1',
    label: 'Lorem Ipsum is',
    value: 'ITEM_1',
    actionCta: 'terms'
  }, {
    id: 'ITEM_2',
    label: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
    actionCta: 'terms',
    value: 'ITEM_2'
  }]
}, getTestId('CheckboxGroupWidgetContainer'));